import { TastePreferencesScreen } from '@/features/setup/screens';
export default TastePreferencesScreen;
